var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.25H2.5C2.16848 4.25 1.85054 4.3817 1.61612 4.61612C1.3817 4.85054 1.25 5.16848 1.25 5.5V15.5C1.25 15.8315 1.3817 16.1495 1.61612 16.3839C1.85054 16.6183 2.16848 16.75 2.5 16.75H17.5C17.8315 16.75 18.1495 16.6183 18.3839 16.3839C18.6183 16.1495 18.75 15.8315 18.75 15.5V5.5C18.75 5.16848 18.6183 4.85054 18.3839 4.61612C18.1495 4.3817 17.8315 4.25 17.5 4.25ZM16.125 5.5L10 9.7375L3.875 5.5H16.125ZM2.5 15.5V6.06875L9.64375 11.0125C9.74837 11.0851 9.87267 11.124 10 11.124C10.1273 11.124 10.2516 11.0851 10.3562 11.0125L17.5 6.06875V15.5H2.5Z",
    fill: "#3E423F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonEmail);
export default __webpack_public_path__ + "static/media/carbon_email.e5f173064c5a07d1c62489fbe95632b4.svg";
export { ForwardRef as ReactComponent };